import http from '@/clients/Axios'
import { isEmail, isNumber } from '@/helpers'
import defineAbilitiesFor from '@/services/rules'
import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'

export const useAuthStore = defineStore('authStore', {
  state: () => ({
    user: useStorage('user', {}),
    userData: {},
    permissions: [],
  }),
  getters: {
    isAuthenticated() {
      return Object.keys(this.user).length > 0
    },
  },
  actions: {
    async login(login, password, ability) {
      let loginForm = isNumber(login)
        ? { phone: login, password: password }
        : isEmail(login)
        ? { email: login, password: password }
        : { username: login, password: password }

      try {
        const res = await http.post('/user/login', loginForm)

        if (res.data.status !== 1) {
          throw new Error(res.data.message || 'Login gagal')
        }

        // save token
        localStorage.setItem('aid', res.data.data.token)
        localStorage.setItem('refresh', res.data.data.refresh_token)

        // get current user
        const meRes = await http.get('/user/me')

        const me = meRes.data.data

        this.user = {
          id: me.id,
          username: me.username,
          email: me.email,
          name: me.name,
          roles: me.roles,
          permissions: me.permissions,
        }

        this.permissions = me.permissions || []

        // update CASL ability
        ability.update(defineAbilitiesFor(this.permissions))

        // optional company profile
        const profileRes = await http.get('/profile')

        if (profileRes.data?.data?.name) {
          localStorage.setItem('appCompany', profileRes.data.data.name)
          this.appCompany = profileRes.data.data.name
        }

        this.emitUpdateEvent()
      } catch (error) {
        console.error('Login error:', error)
        throw error
      }
    },
    async refreshPermission(ability) {
      this.permissions = this.user.permissions || []

      if (this.user && this.permissions.length > 0) {
        ability.update(defineAbilitiesFor(this.permissions))
      }
    },
    async redirectLogout() {
      await http.post('/user/logout').then(async (res) => {
        if (res.data.status === 1) {
          localStorage.clear()
          this.user = {}
        }
      })
    },
    emitUpdateEvent() {
      window.dispatchEvent(new Event('authUpdated')) // <-- Notify App.vue
    },
    logout() {
      localStorage.clear()
      this.user = {}
    },
  },
})
